import { noop as r } from "./atoms-v2887.js";
let e = r, i = r;
process.env.NODE_ENV !== "production" && (e = (o, n) => {
  !o && typeof console < "u" && console.warn(n);
}, i = (o, n) => {
  if (!o)
    throw new Error(n);
});
export {
  i as invariant,
  e as warning
};
